import { Trans } from '@lingui/react/macro'
import { maintenanceLogHooks } from '$src/lib/trpcHooks'
import { ActionIcon, Card, Group, Stack, Text } from '@mantine/core'
import { formatEuros, sum } from '@markku/utils'
import { IconChevronRight, IconCoinEuro } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'

interface FinancialQuickCardProps {
  propertyId: number
}

export function FinancialQuickCard({ propertyId }: FinancialQuickCardProps) {
  const year = new Date().getFullYear()

  const { data: logsData } = maintenanceLogHooks.useList({
    pageSize: 1000,
    filters: {
      $and: [
        { propertyId: { eq: propertyId } },
        { completedDate: { gte: `${year}-01-01` } },
        { completedDate: { lte: `${year}-12-31` } },
      ],
    },
  })

  const logs = logsData?.data || []

  const totalCost = sum(
    logs.map((l) => (l.actualCost ? parseFloat(l.actualCost) : 0)),
  )

  return (
    <Card
      radius="lg"
      withBorder
      component={Link}
      to="/maintenance-costs"
      // @ts-expect-error - propertyId type
      search={{ propertyId }}
      style={{ cursor: 'pointer', textDecoration: 'none' }}
    >
      <Group justify="space-between">
        <Stack gap="xs">
          <Group gap="xs">
            <IconCoinEuro size={20} color="var(--mantine-color-gray-6)" />
            <Text fw={600}>
              <Trans>Costs for {year}</Trans>
            </Text>
          </Group>
          <Text fw={600} c="gray.8">
            {formatEuros(totalCost)}
          </Text>
        </Stack>
        <ActionIcon variant="subtle" color="gray">
          <IconChevronRight size={20} />
        </ActionIcon>
      </Group>
    </Card>
  )
}
